export default __webpack_public_path__ + "92140b57db2b86ff652a2d2110e73dcf.svg";